interface HtmlProps {
  children: string,
}

const Html = ({ children }: HtmlProps) =>
  <span dangerouslySetInnerHTML={{ __html: children }} />

export default Html
